import styled from 'styled-components';

const colors = {
  purple: '#6A1B9A',
  green: '#4CAF50',
  greenDark: '#2E7D32',
  greenLight: '#E8F5E9',
  gray: '#757575',
  grayLight: '#F5F5F5',
  white: '#FFFFFF',
  red: '#F44336',
};

export const TitleSection = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h2`
  color: ${colors.green};
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

export const Subtitle = styled.p`
  color: ${colors.gray};
  font-size: 1rem;
`;

export const InstructionsSection = styled.div`
  margin-bottom: 2rem;
`;

export const SectionTitle = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: ${colors.green};
  font-weight: 600;
`;

export const InstructionsText = styled.p`
  margin-bottom: 1rem;
  line-height: 1.5;
  color: ${colors.gray};
  font-size: 0.9rem;
`;

export const OrderDetails = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: ${colors.greenLight};
  border-radius: 8px;
  border: 1px solid #c8e6c9;
`;

export const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const DetailLabel = styled.span`
  color: ${colors.gray};
  font-weight: 500;
`;

export const DetailValue = styled.span`
  color: #333;
  font-weight: 600;
`;

export const Status = styled.span`
  color: ${colors.greenDark};
  font-weight: 600;
`;

export const BarcodeSection = styled.div`
  background: ${colors.white};
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  text-align: center;
  border: 1px solid #e0e0e0;
`;

export const BarcodeNumber = styled.div`
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  letter-spacing: 1px;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0.8rem;
  background: ${colors.grayLight};
  border-radius: 4px;
  border: 1px solid #bdbdbd;
`;

export const BarcodeImage = styled.div`
  margin: 0 auto;
  max-width: 100%;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  padding: 1rem;
  background: ${colors.white};

  & > svg {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  justify-content: center;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const PrimaryButton = styled.button`
  background: ${colors.green};
  color: ${colors.white};
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 0.9rem;
  min-width: 180px;

  &:hover {
    background: ${colors.greenDark};
  }
`;

export const SecondaryButton = styled.button`
  background: ${colors.white};
  color: ${colors.green};
  border: 1px solid ${colors.green};
  padding: 0.8rem 1.5rem;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.9rem;
  min-width: 180px;

  &:hover {
    background: ${colors.greenLight};
  }
`;

export const ConfirmationText = styled.p`
  text-align: center;
  color: ${colors.gray};
  font-size: 0.9rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
`;
